import '@shoelace-style/shoelace/dist/components/details/details.js';

const setupDetails = () => {
	const containers = document.querySelectorAll('[details-group-name]');
	containers.forEach(container => {
		container.addEventListener('sl-show', event => {
			if(event.target.localName === 'sl-details') {
				[...container.querySelectorAll('sl-details')].map(details => (details.open = event.target === details));
			}
		})
		container.addEventListener('sl-after-show', event => {
			const openDetails = container.querySelector('sl-details[open]');
			if(openDetails) {
				const summary = openDetails.querySelector('summary');
				setTimeout(() => summary.scrollIntoView({ block: 'center' }), 100);
			}
		})
	});
}

export { setupDetails };
